import './App.css';
import monkImage from './assets/monk.png';
import backgroundImage from './assets/webBackground.png';

function App() {
  return (
    <div
      className="landing"
      style={{ backgroundImage: `linear-gradient(to right, rgba(0,0,0,0.8), rgba(0,0,0,0.1)), url(${backgroundImage})` }}
    >
      <div className="left-block">
        <h1>Monkly</h1>
        <div className="content-block">
          <p>Find peace in code and chaos in serenity.</p>
          <div className="button-row">
        {/* <a target="_blank" rel="noopener noreferrer">Download on AppStore</a>
<a target="_blank" rel="noopener noreferrer">Get it on Google Play</a> */}
          </div>
        </div>
      </div>
      <img src={monkImage} alt="Monk character" className="monk-image" />
    </div>
  );
}

export default App;
